import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.7071 2.70711C15.0976 2.31658 15.0976 1.68342 14.7071 1.29289C14.3166 0.902369 13.6834 0.902369 13.2929 1.29289L14.7071 2.70711ZM6 10L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071L6 10ZM13.2929 18.7071C13.6834 19.0976 14.3166 19.0976 14.7071 18.7071C15.0976 18.3166 15.0976 17.6834 14.7071 17.2929L13.2929 18.7071ZM13.2929 1.29289L5.29289 9.29289L6.70711 10.7071L14.7071 2.70711L13.2929 1.29289ZM5.29289 10.7071L13.2929 18.7071L14.7071 17.2929L6.70711 9.29289L5.29289 10.7071Z'
      fill='#0D0D0D'
    />
  </svg>
)
